import { Image } from '@/components/common/Image';
import { PromotionCtaButton } from '../components/PromotionCtaButton';
import { HERO_BULLETS } from '../data';

export function HeroSection() {
  return (
    <section className="bg-white">
      <div className="mx-auto grid w-full max-w-7xl items-start gap-10 px-4 pt-7 pb-7 sm:px-6 sm:pt-10 sm:pb-10 lg:grid-cols-[1.05fr_1fr] lg:gap-12 lg:px-8 lg:pt-12 lg:pb-12">
        <div className="flex flex-col">
          <div className="inline-flex items-center gap-2.5 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-600 sm:text-sm">
            <span className="size-2 rounded-full bg-brand-600" aria-hidden="true" />
            Enrollment Open &middot; Summer 2026
          </div>

          <h1 className="mt-5 text-4xl font-extrabold leading-[1.05] tracking-tight text-slate-900 sm:text-5xl lg:text-[3.5rem]">
            10-Week Math
            <br />
            <span className="bg-linear-to-r from-brand-500 to-brand-700 bg-clip-text text-transparent">
              Summer
            </span>{' '}
            Bootcamp
          </h1>

          <p className="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg">
            Small in-person classes in Irving, TX &mdash; built to get your child a year ahead by fall.
          </p>

          <ul className="mt-9 divide-y divide-slate-200 border-y border-slate-200">
            {HERO_BULLETS.map((bullet) => {
              const Icon = bullet.icon;
              return (
                <li
                  key={bullet.title}
                  className="flex items-center gap-4 py-4 sm:gap-5"
                >
                  <div className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-brand-50 ring-1 ring-brand-100">
                    <Icon className="size-5 text-brand-600" aria-hidden="true" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-base font-bold text-slate-900">
                      {bullet.title}
                    </p>
                    <p className="text-sm text-slate-600">{bullet.subtitle}</p>
                  </div>
                  {bullet.badge && (
                    <span
                      className={`shrink-0 rounded-full px-3 py-1 text-sm font-bold ${
                        bullet.badgeVariant === 'green'
                          ? 'bg-emerald-100 text-emerald-700'
                          : 'bg-slate-100 text-slate-700'
                      }`}
                    >
                      {bullet.badge}
                    </span>
                  )}
                </li>
              );
            })}
          </ul>

          <div className="mt-8 flex flex-wrap items-center gap-5">
            <PromotionCtaButton underline>1-Minute Enrollment</PromotionCtaButton>
            <p className="text-xl text-slate-700 sm:text-2xl">
              Enrollment closes <span className="font-bold text-slate-900">May 24</span>
            </p>
          </div>
        </div>

        <div className="relative">
          <div className="relative mx-auto aspect-square w-full max-w-xl overflow-hidden rounded-3xl shadow-xl ring-1 ring-slate-200 lg:aspect-auto lg:h-[620px] lg:max-w-none">
            <Image
              src="/promotion-images/bg-4.png"
              alt="Mind Mirth math tutoring in session"
              className="h-full w-full object-cover"
              priority
            />
          </div>
        </div>
      </div>
    </section>
  );
}